import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import type { GearRate, PaginatedResponse } from '@/lib/types';

export interface GearRateFilters {
  page?: number;
  page_size?: number;
  gear_request_template?: number | '';
  gear_model?: number | '';
  ordering?: string;
}

function cleanFilters(filters: GearRateFilters): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== '' && value !== undefined && value !== null)
  );
}

export function useGearRates(filters: GearRateFilters = {}) {
  const clean = cleanFilters(filters);

  return useQuery({
    queryKey: queryKeys.gearRates.list(clean),
    queryFn: async (): Promise<PaginatedResponse<GearRate>> => {
      const response = await apiClient.get<PaginatedResponse<GearRate>>('/api/v1/gear-rates/', {
        params: clean,
      });
      return response.data;
    },
  });
}
